import HttpClient from "../helpers/HttpClient"
import { HttpError, isError } from "../helpers/Error"
import SmsConfiguration, { SmsConfigurationDto } from "./SmsConfiguration"

class SmsConfigurationService {
    httpClient: HttpClient<SmsConfiguration,
        SmsConfigurationDto> = new HttpClient<SmsConfiguration, SmsConfigurationDto>(SmsConfiguration)

    async get(accountId: string): Promise<SmsConfiguration | HttpError> {
        const res = await this.httpClient.get(`/sms-configuration/${accountId}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as SmsConfiguration
    }

}

const instance = new SmsConfigurationService()
export default instance


// WEBPACK FOOTER //
// ./src/state/sms/SmsService.ts